export default __webpack_public_path__ + "static/hero-8-b4854573c031eb58172af2290ca8705b.webp";